import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerService } from '../core/service/server.service';
import { UsuarioService } from '../services/usuario.service';


@Injectable({
  providedIn: 'root',
})
export class AuthService {
  isLoggedIn = false;
  redirectUrl: string;

  constructor(private server: ServerService, private usuarioService: UsuarioService) {
  }

  login(login: string, senha: string): Observable<boolean> {
    return Observable.create(
      (obs) => {
        this.server.post('auth/login', {login: login, senha: senha}).subscribe(
          (dados) => {
            this.isLoggedIn = true;
            this.server.setTokenAcesso(dados.token);
            this.usuarioService.setUsuario(dados.usuario);
            obs.next(true);
          },
          (err) => {
            this.server.setTokenAcesso('');
            this.usuarioService.setUsuario(null);
            this.isLoggedIn = false;
            console.error(err);
            obs.next(false);
          },
          () => {
            obs.complete();
          }
        );
      }
    );
  }

  logout(): void {
    this.isLoggedIn = false;
    this.server.setTokenAcesso('');
  }
}
